<template>
  <div>
    <ul
      class="side_menu"
      :key="'sidemenu_sub_menu_' + item.label"
      v-for="item in menu"
    >
      <template v-if="item.flag && route().current(item.flag)">
        <li class="relative side_menu side_menu_active">
          <div :class="'ml-' + level">
            <div class="active_square"></div>
            {{ item.label }}
          </div>
        </li>
      </template>
      <template v-else>
        <Link
          class="side_menu side_menu_inactive cursor-pointer"
          as="li"
          :href="item.to"
        >
          <div :class="'ml-' + level">{{ item.label }}</div>
        </Link>
      </template>
      <ul v-if="item.menu">
        <sub-menu
          class="w-full"
          :menu="item.menu"
          :key="'sidemenu_sub_menu_' + menu.label + '_sub'"
          :level="level + 1"
        />
      </ul>
    </ul>
  </div>
</template>

<script>
export default {
  name: "sub-menu",
  props: {
    level: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      menu: [
        {
          label: "個人資料",
          to: route("user.profile"),
          flag: "user.profile*",
        },
        {
          label: "系統通知",
          to: route("user.notifications"),
          flag: "user.notifications*",
        },
        {
          label: "訂單查詢",
          to: route("user.orders"),
          flag: "user.orders*",
        },
        {
          label: "回饋查詢",
          to: route("user.rebates"),
          flag: "user.rebates*",
        },
        {
          label: "收藏清單",
          to: route("user.collection"),
          flag: "user.collection*",
        },
        {
          label: "推薦成員查看",
          to: route("user.members"),
          flag: "user.members*",
        },
      ],
    };
  },
};
</script>

<style lang="postcss">
.active_square {
  @apply absolute w-1.5 h-6 left-0 bg-fh-blue;
}
</style>